import { FC } from 'react';
import styled from 'styled-components';

const RadioButton = styled.span<{ isEnabled?: boolean }>`
    display: inline-flex;
    width: 12px;
    height: 12px;
    background-color: #ffffff;
    border-radius: 7px;
    border-style: solid;
    border-color: #969497;
    margin-right: 10px;
    margin-top: 6px;
    border-width: 1px;
    flex-shrink: 0;
    align-items: center;
    justify-content: center;
    cursor: ${props => (props.isEnabled ? 'pointer' : 'default')};
`;

const RadioButtonChecked = styled.span<{ isEnabled: boolean }>`
    display: inline-block;
    width: 8px;
    height: 8px;
    background-color: ${props => (props.isEnabled ? '#7fc31c' : '#7a7a7a')};
    border-radius: 4px;
`;

const RadioButtonLine = styled.div<{ isEnabled?: boolean }>`
    user-select: none;
    cursor: ${props => (props.isEnabled ? 'pointer' : 'default')};
    display: flex;
`;

const RadioButtonText = styled.span<{ isEnabled: boolean }>`
    font-size: 15px;
    cursor: ${props => (props.isEnabled ? 'pointer' : 'default')};
`;

const RadioButtonContainer = styled.div`
    display: inline-flex;
    flex-direction: column;
`;

type Option = {
    key: string;
    value: string;
};

interface Props {
    isEnabled?: boolean;
    onRadioChanged: (key: string) => void;
    options: Option[];
    selectedOption?: string | null;
    className?: string;
}

export const LocalContentRadioButtonGroup: FC<Props> = props => {
    function onClickHandler(key) {
        props.onRadioChanged(key);
    }

    return (
        <RadioButtonContainer className={props?.className ?? ''}>
            {props.options.map(option => {
                const enabled = props.options.length > 1;
                return (
                    <RadioButtonLine key={option.key}>
                        <RadioButton
                            onClick={enabled ? () => onClickHandler(option.key) : () => {}}
                            isEnabled={enabled}
                        >
                            {props.selectedOption === option.key ? <RadioButtonChecked isEnabled={enabled} /> : null}
                        </RadioButton>
                        <RadioButtonText
                            onClick={enabled ? () => onClickHandler(option.key) : () => {}}
                            isEnabled={enabled}
                        >
                            {option.value}
                        </RadioButtonText>
                    </RadioButtonLine>
                );
            })}
        </RadioButtonContainer>
    );
};
